import './areas.component.scss'
import {createMap} from '../../application/core/map-service'

const mapElement = document.getElementById('areas-map');


if (mapElement) {
  const zoom = parseInt(mapElement.dataset.zoom);
  const lcs = dataCord.map(
    (locationNode) => {
      const local = locationNode.data_location.split(',');
      const marker = locationNode.data_marker;
      const linkItem = locationNode.data_addr;
      return {
        name: linkItem,
        lat: parseFloat(local[0]) || 0,
        lng: parseFloat(local[1]) || 0,
        url: linkItem?.href,
        marker: marker
      }
    }
  );
  createMap(mapElement, lcs, zoom, true);
  /*
  const locations = Array.from(document.querySelectorAll('.location-item')).map(
    (locationNode) => {
      const local = locationNode.dataset.location.split(',')
      const marker = locationNode.dataset.marker
      const linkItem = locationNode.querySelector('a')
      return {
        name: locationNode.innerHTML,
        lat: parseFloat(local[0]) || 0,
        lng: parseFloat(local[1]) || 0,
        url: linkItem?.href,
        marker: marker
      }
    }
  )
  */
  /*createMap(mapElement, locations, zoom, true)*/
}